import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitAssessment = async (payload) => {
  const { data } = await axios.post(`${API}/assessment`, payload);
  return data;
};

export const sendOtp = async (phone) => {
  const { data } = await axios.post(`${API}/otp/send`, { phone });
  return data;
};

export const verifyOtp = async (phone, code) => {
  const { data } = await axios.post(`${API}/otp/verify`, { phone, code });
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/booking`, payload);
  return data;
};

export const trackVisit = async (path = "/") => {
  const { data } = await axios.post(`${API}/track-visit`, { path });
  return data;
};

export const getImpactStats = async () => {
  const { data } = await axios.get(`${API}/impact-stats`);
  return data;
};

export const updateBookingDetails = async (id, payload) => {
  const { data } = await axios.patch(`${API}/bookings/${id}/details`, payload);
  return data;
};

export const getSeats = async () => {
  const { data } = await axios.get(`${API}/seats`);
  return data;
};

export const getReport = async (id) => {
  const { data } = await axios.get(`${API}/report/${id}`);
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const getPaymentConfig = async () => {
  const { data } = await axios.get(`${API}/payment/config`);
  return data;
};

export const createPaymentOrder = async (payload) => {
  const { data } = await axios.post(`${API}/payment/create-order`, payload);
  return data;
};

export const verifyPayment = async (payload) => {
  const { data } = await axios.post(`${API}/payment/verify`, payload);
  return data;
};

export const validatePromo = async (code, pkg = "basic") => {
  const { data } = await axios.post(`${API}/promo/validate`, { code, package: pkg });
  return data;
};

export const getPaymentRecovery = async (token) => {
  const { data } = await axios.get(`${API}/payment/recovery/${encodeURIComponent(token)}`);
  return data;
};

